import { APIAdapter } from "../../../../helpers/api_helper";
import axios from "axios";
const api = new APIAdapter();


  export const getAllMerchent = async () => {
      try {
        const response = await api.get(`/merchants`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  
  export const getMarchandById = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  
  export const getCompanyByMarchandId = async (merchandId) => {
    try {
      const response = await api.get(`/merchants/${merchandId}/companies`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const deleteMerchent = async (id) => {
    try {
      const response = await api.delete(`/merchants/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const activeMerchant = async ( accountId ) => {
    try {
      const response = await api.put(`/merchants/activate/${accountId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  export const deactiveMerchant = async ( accountId ) => {
    try {
      const response = await api.put(`/merchants/deactivate/${accountId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const updateKycStatus = async (merchantId, status) => {
  try {
    const response = await api.put(
      `/merchants/${merchantId}/kyc?status=${status}`,
      null, 
      {
        params: { status } 
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

   export const getBusinessMarchandById = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}/developer-accounts`);
        return response;
      } catch (error) {
        throw error;
      }
  };
     export const getVersementByMarchand = async (merchandId) => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_TRANSACTION}/manage/pay-out/merchant/${merchandId}`);
        return response.data;
      } catch (error) {
        throw error;
      }
  };
   export const getMerchantTotalRevenu = async () => {
        try {
          const response = await api.get(`/admin/dashboard/merchants/total-revenue`);
          return response;
        } catch (error) {
          throw error;
        }
    }

export const createEspaceClient = async (email) => {
  try {
    const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));

    const response = await axios.post(process.env.REACT_APP_API_AUTH+
      `/auth/espace-client?email=${encodeURIComponent(email)}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${currentUser?.token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Erreur createEspaceClient :", error.response?.data || error);
    throw error;
  }
};
  export const getDocumentsByMarchand = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}/kyc-files`);
       
        return response;
      } catch (error) {
        throw error;
      }
  };


  
